<script lang="ts">
  import type { OrganizationOnboardingResponse } from "../../../../../../../../../../../../api/kehrblatt/organization-onboarding"
  import GuidedProgressDashboardCard from "../../../../_shared/_modules/guided-progress-dashboard-card"
  import {
    onboardingActiveStep,
    onboardingProgressCounts,
    onboardingSummaryDescription,
  } from "../../_shared/_logic/onboarding-presentation"

  let {
    onboarding,
    loading = false,
    onOpen,
  }: {
    onboarding: OrganizationOnboardingResponse
    loading?: boolean
    onOpen: () => void
  } = $props()

  const counts = $derived(onboardingProgressCounts(onboarding))
  const activeStep = $derived(onboardingActiveStep(onboarding))
  const cardSteps = $derived(
    onboarding.steps.map((step) => ({
      id: step.key,
      title: step.title,
      state:
        step.status === "COMPLETED"
          ? ("completed" as const)
          : step.status === "SKIPPED"
            ? ("skipped" as const)
            : ("pending" as const),
    })),
  )
</script>

<GuidedProgressDashboardCard
  label="Einrichtung"
  actionLabel="Einrichtung fortfahren"
  headline={`${counts.completed} von ${counts.total} Schritten abgeschlossen`}
  description={onboardingSummaryDescription(onboarding)}
  currentItemLabel={activeStep?.status === "OPEN" ? `Nächste Aufgabe: ${activeStep.title}` : null}
  metrics={[
    { value: counts.completed, label: "Erledigt" },
    { value: counts.open, label: "Offen" },
    { value: counts.skipped, label: "Übersprungen" },
  ]}
  steps={cardSteps}
  progressLabel="Einrichtungsfortschritt"
  {loading}
  {onOpen}
/>
